<template>
    <div class="fs-main">
      <!-- Oben: Template Tab -->
      <FSTemplates />
      <!-- Hauptbereich mit Dateisystem und Sidebar -->
      <div class="fs-content">
        <div class="dbemails-container">
          <DbTreeWrapper ref="dbTreeWrapper"/>
        </div>
        <div class="fs-sidebar-container">
          <FSSidebar @createFolder="handleCreateFolder()"/>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import FSTemplates from './FSTemplateDrawer.vue'
  import FSSidebar from './FSSidebar.vue'
  import DbTreeWrapper from './FSDbTreeWrapper.vue'
  import { ref } from 'vue'

  const dbTreeWrapper = ref(null)

  function handleCreateFolder() {
    console.log('test')
  if (dbTreeWrapper.value) {
    dbTreeWrapper.value.createFolder()
  }
}
  </script>
  
  <style scoped>
  .fs-main {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 50px);
  }
  
  .fs-content {
    flex: 1;
    display: flex;
  }
  
  .dbemails-container {
    flex: 3; /* ca. 75 % der Breite */
    border-right: 1px solid #ccc;
    padding: 10px;
  }
  
  .fs-sidebar-container {
    flex: 2; /* ca. 25 % der Breite */
    padding: 10px;
  }
  </style>
  
  